import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LogoIvan from '@/imgs/logo-horion.png';
import { useTranslation } from 'react-i18next';
import { StyledFooter, StyledWhats, LinkPolitices } from './styles';

const Footer = (props) => {
  const { transparencyMenu } = props;
  const { t } = useTranslation();

  useEffect(() => {
    if (!document.getElementById('ra-embed-verified-seal')) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'ra-embed-verified-seal';
      script.src = 'https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js';
      script.setAttribute('data-id', 'QzgxdUxZQ3NtRUN1WmthSzptb250YWdub2xpLW9yZ2FuaXphY2FvLWxvZ2lzdGljYS1sdGRh');
      script.setAttribute('data-target', 'ra-verified-seal');
      script.setAttribute('data-model', '1');
      document.getElementById('ra-verified-seal').appendChild(script);
    }
  }, []);

  return (
    <>
      <StyledFooter>
        <div>
          <LinkPolitices href="/politicas" rel='noreferrer'>
            <i className="fas fa-shield" / >
            {t('Política de Privacidade')}
          </LinkPolitices>
          <p>{t('Todos os direitos reservados © - Spartacus Brazil')}</p>
        </div>

        <div id='ra-verified-seal' className="reclame-aqui" />

        <div>
          <a href='http://ivanoliveira.com.br' rel='noreferrer' target='_blank' className="develop-by">
            <span>{t('Desenvolvido por')}</span>
            <img src={LogoIvan} alt='Logo Ivan Oliveira' />
          </a>
        </div>

      </StyledFooter>
      <StyledWhats className={transparencyMenu ? 'show' : ''}>
        <a href='https://wa.me/5511989414044' rel='noreferrer' target='_blank'>
          <i className='fa-brands fa-whatsapp' />
          <span>{t('Fale agora com a Spartacus Brazil')}</span>
        </a>
      </StyledWhats>
    </>
  );
};

Footer.propTypes = {
  transparencyMenu: PropTypes.bool.isRequired,
};

export default Footer;
